import useLoginForm from "../hooks/useLoginForm"
import MyPageErrorMessages from "../../../components/mypage/MyPageErrorMessages"
import { PasswordTextField } from "../../../components/TextField/PasswordTextField"
import { TextField } from "../../../components/TextField/TextField"
import AccountLockedMessage from "./AccountLockedMessage"
import LINKS from "../constant/links"

type Props = {
  onSwitchToSignup?: () => void
  onLogin?: () => void
  shouldRedirect?: boolean
}

export const LoginContent = ({ onSwitchToSignup, onLogin, shouldRedirect }: Props = {}) => {
  const { loginIdProps, passwordProps, errorMessage, isAccountLocked, login, isLoading } = useLoginForm({
    onLogin,
    shouldRedirect,
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    login()
  }

  return (
    <div className="relative flex h-[600px] w-[800px] flex-col items-center rounded-r-xl bg-white px-[60px] pb-[0px] pt-[102px] text-sm">
      <p className="mb-4 text-xl font-bold">ログイン</p>
      {errorMessage && (
        <div className="mb-4">
          {isAccountLocked ? (
            <AccountLockedMessage message={errorMessage} passwordResetLink={LINKS.PASSWORD_RESET} />
          ) : (
            <MyPageErrorMessages>{errorMessage}</MyPageErrorMessages>
          )}
        </div>
      )}
      <form className={`self-stretch ${errorMessage ? "" : "mt-[11px]"}`} onSubmit={handleSubmit}>
        <TextField
          {...loginIdProps}
          type="text"
          placeholder="メールアドレス または 6桁のID"
          isError={false}
          id="id"
          className="mb-4"
        />
        <PasswordTextField
          {...passwordProps}
          placeholder="パスワード"
          isError={false}
          id="password"
          className="mb-2"
          autoComplete="current-password"
        />
        <div className="mb-12 flex justify-end">
          <a
            href={LINKS.PASSWORD_RESET}
            className="cursor-pointer text-[10px] font-bold leading-[1.75] text-green-600 no-underline hover:underline"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            パスワードの再発行
          </a>
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className={`flex h-[38px] w-[280px] items-center justify-center rounded-[6px] px-5 py-0 text-[14px] font-bold text-white transition-colors ${
            isLoading ? "cursor-not-allowed bg-slate-200" : "cursor-pointer bg-green-600 hover:bg-green-700"
          }`}
        >
          ログイン
        </button>
        <div className="mb-12 mt-4 flex justify-center">
          <span
            className="cursor-pointer text-xs font-bold leading-[1.75] text-green-600 no-underline hover:underline"
            onClick={() => onSwitchToSignup?.()}
          >
            P板.comアカウントをお持ちでない方はこちら
          </span>
        </div>
      </form>
      <div className="absolute left-[63px] top-[542px] flex h-[21px] w-[280px] items-center justify-center gap-2 text-[10px]">
        <a
          href={LINKS.ABOUT_LOGIN}
          className="text-right text-[10px] font-bold leading-[1.75] text-[#9fa6ad]"
          target="_blank"
          rel="noreferrer"
        >
          ログインでお困りの方へ
        </a>
      </div>
    </div>
  )
}
